import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WebRoutes } from '@shared/constants/web-routes.enum';
import { AuthStore } from '@features/shared/auth/presentation/store/auth.store';
import { ClinicWarmupSessionService } from '../services/clinic-warmup-session.service';

// Stops `/preparando` from replaying the whole sweep every time it is entered. The walk spends real
// provider budget -- it is the single most expensive thing the panel does -- so a refresh, a Back,
// or a second tab arriving minutes after the first one finished goes straight to the dashboard
// instead.
//
// A guard rather than a check inside the page on purpose: redirecting from here means the splash
// never constructs, so there is no frame of it to flash before the redirect lands.
export const clinicWarmupGuard: CanActivateFn = () => {
  const user = inject(AuthStore).user();
  if (!inject(ClinicWarmupSessionService).hasFreshWarmupFor(user)) return true;

  return inject(Router).createUrlTree([WebRoutes.Dashboard]);
};
